import React from 'react';

import {Text, StyleSheet} from 'react-native';

import {useAcknowledgements} from '../../context/AcknowledgementsContext';

import {CONTENT_TYPES} from '../../constants/trustContent';

export const Status = ({value, acknowledged}) => {
  return (
    <>
      <Text style={[styles.separator]}> • </Text>
      <Text style={[styles.status, acknowledged && styles.acknowledged]}>
        {value}
      </Text>
    </>
  );
};

const AcknowledgementStatus = ({id}) => {
  const {isContentAcknowledged} = useAcknowledgements();
  const isAcknowledged = isContentAcknowledged(id);
  return (
    <Status
      value={isAcknowledged ? 'Acknowledged' : 'Unacknowledged'}
      acknowledged={isAcknowledged}
    />
  );
};

const getStatusForType = (type, item, screenProps) => {
  switch (type) {
    case CONTENT_TYPES.PGDS: {
      const acknowledged = item.pgdInfo.acknowledged;
      return (
        <Status
          value={acknowledged ? 'Authorised' : 'Unauthorised'}
          acknowledged={acknowledged}
        />
      );
    }
    case CONTENT_TYPES.PMAS: {
      const acknowledged = item.pgdInfo.acknowledged;
      return (
        <Status
          value={acknowledged ? 'Authorised' : 'Unauthorised'}
          acknowledged={acknowledged}
        />
      );
    }
    case CONTENT_TYPES.CASE_STUDIES: {
      return null;
    }
    case CONTENT_TYPES.PODCASTS: {
      const currentPodcastHistory = screenProps.audioHistory?.find(
        pod => pod.audioId === item.Id,
      );
      const hasListened = Boolean(currentPodcastHistory?.secondsListened >= 60);

      return (
        <Status
          value={hasListened ? 'Listened' : 'Not Listened'}
          acknowledged={hasListened}
        />
      );
    }
    case CONTENT_TYPES.VIDEOS: {
      if (!item.SupportsAck) {
        return null;
      }

      return <AcknowledgementStatus id={item.id} />;
    }
    case CONTENT_TYPES.PSIRF: {
      return <AcknowledgementStatus id={item.ID} />;
    }
    case CONTENT_TYPES.STANDBY_CPD: {
      return null;
    }
    default:
      return null;
  }
};

const TrustStatus = ({type, item, screenProps}) => {
  return getStatusForType(type, item, screenProps);
};

const styles = StyleSheet.create({
  status: {
    color: '#ED242B',
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 14.52,
    letterSpacing: 0,
  },
  acknowledged: {
    color: '#7E7E7E',
  },
  separator: {
    fontWeight: '600',
    fontSize: 12,
    lineHeight: 14.52,
    letterSpacing: 0,
    color: '#798B93',
  },
});

export default TrustStatus;
